/**
 * Product artwork — Vite asset imports (not used by vite.config / Node SEO path).
 * Keys match products.js ids.
 */
import dailyQuizImg from '@/assets/images/games/daily-quiz.png'
import crystalBlastImg from '@/assets/images/games/crystal-blast.png'
import crystalBlast3dImg from '@/assets/images/games/crystal-blast-3d.png'
import inkSurgeImg from '@/assets/images/games/ink-surge.png'
import shootImg from '@/assets/images/games/shoot.png'
import sweetyJumperImg from '@/assets/images/games/sweety-jumper.png'
import snakeImg from '@/assets/images/games/snake.png'
import dontFallImg from '@/assets/images/games/dontfall.png'
import bricksBreakerImg from '@/assets/images/games/BricksBreaker.png'
import diceBlastImg from '@/assets/images/games/DiceBlast.png'
import dotsGameImg from '@/assets/images/extensions/dots-game.png'
import learnBasqueImg from '@/assets/images/extensions/learn-basque.png'
import learnFrenchImg from '@/assets/images/extensions/learn-french.png'
import learnSpanishImg from '@/assets/images/extensions/learn-spanish.png'
import pushupImg from '@/assets/images/apps/pushup.png'
import palmImg from '@/assets/images/apps/palm.png'
import catalanImg from '@/assets/images/apps/catalan.png'
import imagesToDocsImg from '@/assets/images/apps/images-to-documents.png'
import tarotImg from '@/assets/images/apps/tarot.png'
import italianVocabularyImg from '@/assets/images/apps/italian-vocabulary.png'
import portugueseVocabularyImg from '@/assets/images/apps/portuguese-vocabulary.png'
import frenchWordsImg from '@/assets/images/apps/french-words.png'
import spanishVocabularyImg from '@/assets/images/apps/spanish-vocabulary.png'
import basqueVocabularyImg from '@/assets/images/apps/basque-vocabulary.png'
import catalanWordsImg from '@/assets/images/apps/catalan-words.png'
import mageTowerImg from '@/assets/images/apps/mage-tower.png'
import italianVerbsImg from '@/assets/images/apps/italian-verbs.png'
import germanVerbsImg from '@/assets/images/apps/german-verbs.png'
import portugueseVerbsImg from '@/assets/images/apps/portuguese-verbs.png'
import spanishVerbsImg from '@/assets/images/apps/spanish-verbs.png'
import frenchVerbsImg from '@/assets/images/apps/french-verbs.png'
import collageLabImg from '@/assets/images/apps/collage-lab.png'
import sleepNotesAiImg from '@/assets/images/apps/sleep-notes-ai.png'
import dualVideoShotImg from '@/assets/images/apps/dual-video-shot.png'
import shieldScamBlockerImg from '@/assets/images/apps/shield-scam-blocker.png'
import llmApiCostsWidgetImg from '@/assets/images/apps/llm-api-costs-widget.png'

/** @type {Record<string, string>} */
export const productImages = {
  'daily-quiz': dailyQuizImg,
  'crystal-blast-3d': crystalBlast3dImg,
  'ink-surge': inkSurgeImg,
  // Play Store “Mage Tower” icon for Magekeep Siege listing
  'magekeep-siege': mageTowerImg,
  shoot: shootImg,
  'crystal-blast': crystalBlastImg,
  'sweety-jumper': sweetyJumperImg,
  snake: snakeImg,
  'dont-fall': dontFallImg,
  'bricks-breaker': bricksBreakerImg,
  'dice-blast': diceBlastImg,
  'dots-game': dotsGameImg,
  'learn-basque': learnBasqueImg,
  'learn-french': learnFrenchImg,
  'learn-spanish': learnSpanishImg,
  'pushup-challenges': pushupImg,
  'palm-reader-ai': palmImg,
  'catalan-verbs': catalanImg,
  'images-to-documents': imagesToDocsImg,
  tarot: tarotImg,
  'italian-vocabulary': italianVocabularyImg,
  'portuguese-vocabulary': portugueseVocabularyImg,
  'french-words': frenchWordsImg,
  'spanish-vocabulary': spanishVocabularyImg,
  'basque-vocabulary': basqueVocabularyImg,
  'catalan-words': catalanWordsImg,
  'italian-verbs': italianVerbsImg,
  'german-verbs': germanVerbsImg,
  'portuguese-verbs': portugueseVerbsImg,
  'spanish-verbs': spanishVerbsImg,
  'french-verbs': frenchVerbsImg,
  'collage-lab': collageLabImg,
  'sleep-notes-ai': sleepNotesAiImg,
  'dual-video-shot': dualVideoShotImg,
  'shield-scam-blocker': shieldScamBlockerImg,
  'llm-api-costs-widget': llmApiCostsWidgetImg,
}

/**
 * @param {string} id
 * @returns {string|undefined}
 */
export function imageForProduct(id) {
  return productImages[id]
}
